import { Component, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Menu } from 'src/app/ndm/models/menu.model';
import { AuthService } from 'src/app/services/authenticate.service';
import { CommonService } from 'src/app/services/common.service';
import { MasterService } from 'src/app/services/masters.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SharedService } from 'src/app/services/shared.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';


@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnDestroy, OnInit {
  @Output() menuEvent = new EventEmitter<boolean>();
  authenticated: boolean = false;
  intervalId: any = null;
  menuData: Menu[] = [];
  showMenu: boolean = false;
  showChildMenu: boolean = true;
  constructor(private commonService: CommonService
    , private router: Router
    , private authService: AuthService,
    private loader: LoaderService,

    private masterService: MasterService,
    private sharedService: SharedService,
    private toast: NotificationService,
  ) {

  }

  logout() {
    this.loader.start();
    this.authService.logout().subscribe(res => {
      this.loader.stop();
      clearInterval(this.intervalId);
      sessionStorage.clear();
      this.authenticated = false;
      this.router.navigate(['./login'])
    })
  }



  loadMenu() {
    if (this.authService.getIsPasswordSet() == 'false') {
      this.showMenu = false;
    }

    this.sharedService.menuList.subscribe((res: any) => {

      if (this.authService.getIsPasswordSet() == 'false') {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
      this.menuData = [];
      this.menuData = res;
      this.sharedService.setMenuInfo(JSON.stringify(res));
    },
      (error: any) => {
        this.loader.stop();
        this.toast.showException(error.error);
      }
    );

  }

  expandMenu(menu: Menu) {
    this.menuData.forEach(element => {
      if (element.label == menu.label) {
        element.expand = element.expand == true ? false : true;
      } else {
        element.expand = false;
      }

    });
  }


  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  hideAndShowMenu(menu: Menu) {
    this.showChildMenu = false;
    setTimeout(() => {
      this.showChildMenu = true;
    }, 50);

    if (menu.label! !== "Management") {
      this.loader.start();
      setTimeout(() => {
        this.showChildMenu = true;
        this.loader.stop();
      }, 1000);
    }

  }


  ngOnInit(): void {
    this.loadMenu();
    if (this.authService.getToken()) {
      this.authenticated = true;
    }
    let expires: any = this.authService.getExpires();
    if (expires !== null) {
      this.intervalId = setInterval(() => {
        expires = this.authService.getExpires();
        expires = new Date(expires);
        if (new Date(expires?.toString()).getTime() < new Date().getTime()) {
          console.log('session out');
          this.logout();
        }
      }, 1000);
    }
  }
}
